<template lang="pug">
  div
    Card.a8-page-description-card
        h2 {{$t('certsApply.pageTitleText')}}

        Tabs(v-model="currentTab" )
            template(v-for="(tab,index) in tabItems")
                TabPane(:label="$t(`certsApply.${tab.name}`)" :name="tab.name")
                    RcmTable(
                        :esIndex="tab.esIndex"
                        :esIndexFields="tab.esIndexFields"
                        :exportFields="tab.exportFields"
                        :sort="tab.sort"
                        :userCanCreate="tab.userCanCreate"
                        :userCanIndex="false"
                        :userCanEditFilters="false"
                        :userCanEditColumns="false"
                        :userCanExport="false"
                        ref="rcmTable"
                        v-bind:searchView="$options.name"
                        :primarySearchKey="tab.primarySearchKey"
                        :primarySearchKeyI18="tab.primarySearchKeyI18"
                        :userCanToggleFuzzySearch="tab.userCanToggleFuzzySearch"
                        :rowClassInfo="rowClassInfo")
</template>
<script>
import Vue from "vue";
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("TagList", TagList);

import RcmTable from "@/components/RcmTable_v2";
import JsonPoptip from "@/components/JsonPoptip";
import TagList from "@/components/TagList";
import { action, deleteAction } from "./fields.js";

export default {
    name: "CertsApply",
    components: { RcmTable, TagList, JsonPoptip },
    data() {
        return {
            currentTab: "queues",
            tabItems: [
                {
                    name: "queues",
                    esIndex: "rcm-acme-queues",
                    esIndexFields: {
                        action: deleteAction(this, 0),
                        fastEntry: "",
                        queueState: "",
                        groupName: "",
                        serverName: "",
                        sslProvider: "",
                        requestSSLOrderNumber: "",
                        requestSSLState: "",
                        collectSSLState: "",
                        requestAttemptCount: "",
                        collectAttemptCount: "",
                        requestSSLErrMsg: "",
                        collectSSLErrMsg: "",
                        // taskAction: "",
                        addToQueueDate: "",
                        requestSSLDate: "",
                        collectSSLDate: "",
                        requestSSLlValidateFileName: "",
                    },
                    exportFields: [
                        "queueState",
                        "groupName",
                        "serverName",
                        "sslProvider",
                        "requestSSLOrderNumber",
                        "requestSSLState",
                        "collectSSLState",
                        "requestAttemptCount",
                        "collectAttemptCount",
                        "requestSSLErrMsg",
                        "collectSSLErrMsg",
                        "taskAction",
                        "addToQueueDate",
                        "requestSSLDate",
                        "collectSSLDate",
                        "requestSSLlValidateFileName",
                    ],
                    userCanCreate: true,
                    primarySearchKey: "serverName",
                    primarySearchKeyI18: "域名名稱",
                    userCanToggleFuzzySearch: true,
                    // sort: [{ fastEntry: { order: "desc" } }, { addToQueueDate: { order: "desc" } }],
                    // sort: [{ addToQueueDate: { order: "asc" } }],
                },
                {
                    name: "ipQueues",
                    esIndex: "rcm-acme-ip-queues",
                    esIndexFields: {
                        action: deleteAction(this, 1),
                        queueState: "",
                        groupName: "",
                        certpemId: "",
                        serverName: "",
                        ipList: "",
                        sslProvider: "",
                        requestSSLOrderNumber: "",
                        requestAttemptCount: "",
                        collectAttemptCount: "",
                        requestSSLErrMsg: "",
                        collectSSLErrMsg: "",
                        addToQueueDate: "",
                        requestSSLDate: "",
                        collectSSLDate: "",
                        requestSSLlValidateFileName: "",
                    },
                    exportFields: [
                        "queueState",
                        "groupName",
                        "certpemId",
                        "serverName",
                        "sslProvider",
                        "requestSSLOrderNumber",
                        "requestAttemptCount",
                        "collectAttemptCount",
                        "requestSSLErrMsg",
                        "collectSSLErrMsg",
                        "addToQueueDate",
                        "requestSSLDate",
                        "collectSSLDate",
                        "requestSSLlValidateFileName",
                    ],
                    // serverName 現為 <申請單編號>_ipcert, 不是 IP; 改搜 ipList (IP 字串陣列, 後端以 ipList.keyword 比對, 任一 IP 命中即可)
                    primarySearchKey: "ipList",
                    primarySearchKeyI18: "IP 位置",
                    userCanToggleFuzzySearch: true,
                    // 此 index 沒有 modifiedDate 欄位, 不能沿用 RcmTable_v2 的預設排序
                    sort: [{ addToQueueDate: { order: "asc" } }],
                },
                {
                    name: "fastEntry",
                    esIndex: "rcm-acme-domainlist",
                    esIndexFields: { action: action(this, 2), domains: {}, domainFilter: "fastentry" },
                    userCanCreate: false,
                    primarySearchKey: false,
                    primarySearchKeyI18: false,
                    userCanToggleFuzzySearch: false,
                },
                {
                    name: "cnameAllowList",
                    esIndex: "rcm-acme-domainlist",
                    esIndexFields: { action: action(this, 3), domains: {}, domainFilter: "whitelist" },
                    userCanCreate: false,
                    primarySearchKey: false,
                    primarySearchKeyI18: false,
                    userCanToggleFuzzySearch: false,
                },
                {
                    name: "black",
                    esIndex: "rcm-acme-domainlist",
                    esIndexFields: { action: action(this, 4), domains: {}, domainFilter: "blacklist" },
                    userCanCreate: false,
                    primarySearchKey: false,
                    primarySearchKeyI18: false,
                    userCanToggleFuzzySearch: false,
                },
            ],
            rowClassInfo: {
                key: "state",
                values: [],
                valuesNot: ["完成"],
                className: "table-disabled-row",
                defaultClassName: "",
            },
            generalFields: [],
        };
    },
    methods: {},
    computed: {},
};
</script>



// WEBPACK FOOTER //
// src/view/monitor/CertsApply.vue